module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg0OCA4NjRhNDggNDggMCAwIDEgMCA5NmgtNjcyYTQ4IDQ4IDAgMCAxIDAtOTZoNjcyek02MDggNjRhMzIgMzIgMCAwIDEgMzIgMzJ2Mzg0aDE1Ni44YTMyIDMyIDAgMCAxIDIyLjYgNTQuNmwtMjg0LjggMjg0LjhhMzIgMzIgMCAwIDEtNDUuMiAwbC0yODQuOC0yODQuOEEzMiAzMiAwIDAgMSAyMjcuMiA0ODBIMzg0Vjk2YTMyIDMyIDAgMCAxIDMyLTMyaDE5MnoiIGZpbGw9IiMwIiBwLWlkPSIzMTUwIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Down to bottom-filled.svg
// module id = DGtp
// module chunks = 73